// React&NextJS
import React, { useState } from 'react'
// 3rd party libraries
import algoliasearch from 'algoliasearch'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
// Include only the reset
import 'instantsearch.css/themes/reset.css'
// // or include the full Satellite theme
// import 'instantsearch.css/themes/satellite.css'

// Services&Helper functions
import { useKeyDown } from '../../../hooks/useKeyDown'
// Styles
import s from './Search.module.scss'
// Components
import CustomSearchBox from './CustomSearchBox'
import { Container } from '../../core/container/Container'
import InfiniteHits from './infiniteHits'
import { useRouter } from 'next/router'
import helperFunctions from '../../../utils/helperFunctions'

// algolia config
const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
)

export default function Search() {
    const years = helperFunctions.generateArrayOfYears()
    const { query } = useRouter()

    const [filter, setFilter] = useState((query.year as string) ?? '')
    const [options] = useState(years)
    const [searchState, setSearchState] = useState({
        filter: query.year ?? '',
        query: query.name ?? '',
        isLoading: query ? false : true,
        isSearchStalled: true,
    })
    // Search leita nu samstundis eftir nafni en ekki ári.

    useKeyDown(['Enter'], ({ key }) => {
        if (key === 'Enter') {
            //TODO: check for input focus?
            // pressing enter on the page will result in this code running
            // on a sidenote havig a <form> and submitting said form might be a better solution
            const btn = document.getElementById('submit-btn')
            const input = document.getElementById('search-input')
            input.blur()
            btn?.click()
        }
    })

    return (
        <InstantSearch searchClient={client} indexName="memories">
            <Container>
                <div className={s.searchBar}>
                    <CustomSearchBox
                        filter={filter}
                        setFilter={setFilter}
                        setSearchState={setSearchState}
                        options={options}
                        query={query}
                    />

                    {searchState.filter.length == 4 ? (
                        <Configure
                            hitsPerPage={50}
                            filters={`NOT data.scraped=1 AND birthYear:${searchState.filter}`}
                        />
                    ) : (
                        <Configure
                            hitsPerPage={50}
                            filters={`NOT data.scraped=1`}
                        />
                    )}
                </div>
            </Container>

            {/* <FacetList
                attribute="birthYear"
                setOptions={setOptions}
                options={options}
                limit={500}
            /> */}
            {/* Display search results if on /memories page */}
            {!searchState.isSearchStalled && (
                <InfiniteHits isLoading={searchState.isLoading} />
            )}
        </InstantSearch>
    )
}
